import React, { Component } from 'react';
import lottie from 'lottie-web';
import { Utils } from "../../utils/Utils";
import CountdownTimer from "../on/CountdownTimer";
import $ from "jquery";

window.autoPlayList = [];
window.reviewDrawRightTotal = 0;  //  拖对位置的总数量

class AutoMatch extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dragRight: false,   //拖到了正确位置
            selectNum: 0,
            autoDisTipsDraw: "", //小朋友在pc上拖拽不方便，支持点击，默认按顺序在正确位置显示一个框，存放 dstobjs 下的 id，如：GAME_DST_1
            matchDoneElements: [],   //存放每个位置信息，done用，因为可以拖到错的位置，支持在拖下来
            dragAnswers: [],   //存放每个位置信息是否已经拖放元素进来，done用。-1：默认；0-错误；1-正确
            autoDisTipsDraw: props.autoDisTipsDraw, //支持点击选择成功的序号
            dragAnswerDsts: props.dragAnswerDsts || [],
        };
        this.playNum = 0;
        this.len = 0;
        this.curDrawRightArr = []; //拖对项的集合
    }

    componentDidMount() {
        const that = this;
        const { item } = this.props;
        const { dragRight, selectNum, autoDisTipsDraw, matchDoneElements, dragAnswers, dragAnswerDsts } = this.state;

        let content_course = document.getElementById('content_course');
        let mainSize = {
            width: content_course.clientWidth,
            height: content_course.clientHeight
        };

        if (item.actionType === "AudioMutiMatchReplayAction_") {
            let srcObjs = item.detail.srcObjs;
            for (let i = 0; i < srcObjs.length; i++) {
                let srcObj = srcObjs[i];
                window.autoPlayList.push({
                    "id": srcObj.headPhone,
                    "audio": srcObj.audio
                });
                document.getElementById(srcObj.headPhone).setAttribute("class", "playBottom");
                document.getElementById(srcObj.headPhone).setAttribute("audionum", i);
                document.getElementById(srcObj.playBottom).setAttribute("class", "playBottom");
                document.getElementById(srcObj.playBottom).setAttribute("audionum", i);
            }
            that.len = srcObjs.length;
            that.playAudio(0, false);
        } else if (item.actionType === "AUDIOMATCH_REPLAY_TAP") {
            let playBottom = document.getElementsByClassName('playBottom');
            let index = item.detail.index;
            // playBottom[index].onclick = () => {
            let content = document.getElementById("content");
            if (content.className === "content toCenter" || content.className === "content fullScreen") {
                let _num = playBottom[index].getAttribute("audionum");
                that.playAudio(_num, true);
            }
            window.reviewDrawRightTotal++;
            // }
        } else if (item.actionType === "MatchWithDoneReplayAction_" && item.detail.srcObjs) {  //整合match各项的大小和位置
            let newDarwObj = {};
            let matchDoneElements = [];
            that.drawTotal = item.detail.srcObjs.length;
            item.detail.srcObjs.forEach((srcObj, srcIndex) => {
                let eleDom = document.getElementById(srcObj.id);
                if (!newDarwObj[srcObj.id]) {
                    newDarwObj[srcObj.id] = {};
                }

                newDarwObj[srcObj.id]["bigImage"] = srcObj.bigImage;
                newDarwObj[srcObj.id]["defaultPos"] = {
                    //起始位置
                    x: that.isDone && srcObj.pos ? srcObj.pos.x * window.mainSize.width : eleDom.offsetLeft,
                    y: that.isDone && srcObj.pos ? srcObj.pos.y * window.mainSize.height : eleDom.offsetTop
                };
                newDarwObj[srcObj.id]["defaultWidth"] = {
                    //默认展示的大小，这个是除2以后的值
                    width: parseInt(eleDom.style.width, 10),
                    height: parseInt(eleDom.style.height, 10)
                };

                item.detail.matchRules.forEach(matchRule => {
                    if (srcObj.id === matchRule.src) {
                        let dst = matchRule.dst;
                        item.detail.dstObjs.forEach(dstObj => {
                            if (!newDarwObj[srcObj.id]["pos"]) {
                                //存放匹配的正确位置x，y，可能有多个匹配，所以用数组
                                newDarwObj[srcObj.id]["pos"] = [];
                            }
                            if (!newDarwObj[srcObj.id]["matchPos"]) {
                                //存放匹配的范围位置x，y，可能有多个匹配，所以用数组
                                newDarwObj[srcObj.id]["matchPos"] = [];
                            }
                            if (!newDarwObj[srcObj.id]["gameDst"]) {
                                //存放匹配的正确位置名称
                                newDarwObj[srcObj.id]["gameDst"] = [];
                            }
                            if (dst === dstObj.id) {
                                let dstObjSize = {
                                    width: dstObj.size ? dstObj.size.width * window.mainSize.percent : 0,
                                    height: dstObj.size ? dstObj.size.height * window.mainSize.percent : 0
                                };
                                let matchRangeSize = {
                                    width: dstObj.matchRange ? dstObj.matchRange.size.width * window.mainSize.percent : 0,
                                    height: dstObj.matchRange ? dstObj.matchRange.size.height * window.mainSize.percent : 0
                                };
                                newDarwObj[srcObj.id]["bigImageSize"] = dstObjSize; //拖动后的原图大小
                                newDarwObj[srcObj.id]["matchSize"] = dstObj.matchRange ? matchRangeSize : dstObjSize; //匹配区大小
                                newDarwObj[srcObj.id]["matchPos"].push(dstObj.matchRange ? dstObj.matchRange.pos : dstObj.pos); //正确匹配范围
                                newDarwObj[srcObj.id]["pos"].push(dstObj.pos); //正确位置
                                newDarwObj[srcObj.id]["gameDst"].push(dstObj.id);
                                dragAnswers[srcIndex] = -1; //默认位置没有答案
                            }
                            if (!that.curDrawRightArr.includes(dstObj.id)) {
                                that.curDrawRightArr.push(dstObj.id);
                            }
                        });
                    }
                });

                if (item.detail.dstObjs[srcIndex]) {
                    matchDoneElements.push({
                        matchRange: item.detail.dstObjs[srcIndex].matchRange ? item.detail.dstObjs[srcIndex].matchRange.pos : item.detail.dstObjs[srcIndex].pos,
                        pos: item.detail.dstObjs[srcIndex].pos,
                        gameDst: item.detail.dstObjs[srcIndex].id
                    });
                } else {
                    matchDoneElements.push({
                        gameDst: `noDst${srcIndex}`
                    });
                }

                if (dragAnswers[srcIndex] !== -1) {
                    dragAnswers[srcIndex] = -1;//1;  //拖的项多于正确项，因此把多出来的拖拽项直接默认是正确的
                }
            });

            that.setState({
                autoDisTipsDraw: item.detail.dstObjs[0].id
            }, () => {
                window.doneDarwObj = newDarwObj;
                window.matchDoneElements = matchDoneElements;
                window.dragAnswers = dragAnswers;
                window.restoreOption = item.detail.restoreOption;
                console.log(window.doneDarwObj)
            });
        } else if (item.actionType === "MATCH_DONE_REPLAY_MOVE") {
            if (item.detail && item.detail.src && item.detail.src.id) {
                const _id = item.detail.src.id;
                const moveImg = document.getElementById(_id);
                if (moveImg) {
                    let top = item.detail.end_center_pos.y * mainSize.height;
                    let left = item.detail.end_center_pos.x * mainSize.width;
                    let _top = 0;
                    let _left = 0;
                    let _yes = selectNum;
                    let _zIndex = $(moveImg).css('z-index');
                    $(moveImg).css({
                        "background-image": `url(${window.resourceUrl + item.detail.src.bigImage})`,
                        "z-index": _zIndex === "auto" ? 1 : _zIndex
                    }).animate({
                        "top": item.detail.end_center_pos.y * 100 + "%",
                        "left": item.detail.end_center_pos.x * 100 + "%",
                        "width": item.detail.rect && item.detail.rect.size ? item.detail.rect.size.width / 2 : item.detail.src.bigImageSize.width / 2 + "px",
                        "height": item.detail.rect && item.detail.rect.size ? item.detail.rect.size.height / 2 : item.detail.src.bigImageSize.height / 2 + "px",
                    }, item.offsetTime * 60, () => {

                        try {
                            let curImgObj = window.doneDarwObj[_id];
                            let _index = Object.keys(window.doneDarwObj).indexOf(_id);
                            let _width = curImgObj.defaultWidth.width;
                            let _height = curImgObj.defaultWidth.height;
                            let _dragState = 0;
                            let _gameDst = dragAnswerDsts && dragAnswerDsts[_index] ? dragAnswerDsts[_index] : autoDisTipsDraw;   //要传给changeSelect的位置名称，普通模板把当前拖的正确位置返回即可，done模板可能拖到错误的位置，因此需要传错误的位置
                            if (curImgObj.matchPos && curImgObj.matchPos.length) {
                                let matchItem = curImgObj.matchPos[0];
                                if (
                                    !(window.dragAnswers && window.dragAnswers[_index] && window.dragAnswers[_index] > -1) &&  //该位置已经有元素,done模板
                                    !dragAnswerDsts.includes(curImgObj.gameDst[0]) &&  //不在已匹配的数组里面（多图匹配）
                                    (
                                        (curImgObj.gameDst.includes(autoDisTipsDraw)    //当前点击的图片是正确指引序号对应的图片
                                            && curImgObj.defaultPos.x === left && curImgObj.defaultPos.y === top) //在原始的位置

                                        || (matchItem &&
                                            top > matchItem.y * mainSize.height - curImgObj.defaultWidth.height / 2 &&
                                            top < matchItem.y * mainSize.height + curImgObj.defaultWidth.height &&
                                            left > matchItem.x * mainSize.width - curImgObj.defaultWidth.width &&   //左侧匹配范围 - 本身宽度的三分之一
                                            left < matchItem.x * mainSize.width + curImgObj.defaultWidth.width
                                        )
                                    )
                                ) {  //计算范围
                                    _left = curImgObj.pos[0].x * mainSize.width;
                                    _top = curImgObj.pos[0].y * mainSize.height; //拖动后的垂直位置，这个是不变的。  dst-目标位置；matchRange-匹配位置
                                    _width = curImgObj.bigImageSize.width / 2;
                                    _height = curImgObj.bigImageSize.height / 2;
                                    if (!dragRight) {
                                        _yes++;
                                        _dragState = 2;
                                        _gameDst = curImgObj.gameDst[0];
                                        that.setState({
                                            dragRight: true,
                                        });
                                    }
                                } else {
                                    _left = curImgObj.defaultPos.x;
                                    _top = curImgObj.defaultPos.y;
                                }
                            } else {    //没有matchPos信息，也就是没有对应的正确答案
                                _left = curImgObj.defaultPos.x;
                                _top = curImgObj.defaultPos.y;
                            }

                            //done模板，支持拉下来、放在错误的位置
                            if (_dragState !== 2) {   //没有拖对才走这个分支，防止拖对了再走，覆盖了对的
                                let matchItemSize = curImgObj.matchSize;
                                if (!matchItemSize && curImgObj.bigImage) {  //干扰项没有正确匹配位置，直接取元素宽高
                                    let bigImage = document.getElementById(curImgObj.bigImage);
                                    matchItemSize = {
                                        width: parseInt(bigImage.style.width, 10) * 2,
                                        height: parseInt(bigImage.style.height, 10) * 2
                                    }
                                }
                                if (window.matchDoneElements && window.matchDoneElements.length) {
                                    for (let j = 0; j < window.matchDoneElements.length; j++) {
                                        let matchDoneElement = window.matchDoneElements[j];
                                        if (
                                            !(window.dragAnswers && window.dragAnswers[j] && window.dragAnswers[j] > -1) &&  //拖放的位置已经有元素
                                            window.dragAnswers[_index] === -1 &&  //拖放的元素没有占用位置
                                            !dragAnswerDsts.includes(matchDoneElement.gameDst) &&  //不在已匹配的数组里面
                                            (
                                                (matchDoneElement.gameDst === autoDisTipsDraw    //当前点击的图片是正确指引序号对应的图片
                                                    && curImgObj.defaultPos.x === left && curImgObj.defaultPos.y === top) //在原始的位置

                                                || (matchDoneElement && matchDoneElement.matchRange &&
                                                    top > matchDoneElement.matchRange.y * mainSize.height - matchItemSize.height / 2 &&
                                                    top < matchDoneElement.matchRange.y * mainSize.height + matchItemSize.height / 2 &&
                                                    left > matchDoneElement.matchRange.x * mainSize.width - matchItemSize.width / 6 &&   //左侧匹配范围 - 本身宽度的三分之一
                                                    left < matchDoneElement.matchRange.x * mainSize.width + matchItemSize.width / 2)
                                            )
                                        ) {
                                            if (matchDoneElement.pos) {
                                                _left = matchDoneElement.pos.x * mainSize.width;
                                                _top = matchDoneElement.pos.y * mainSize.height;
                                            }
                                            _width = curImgObj.bigImageSize ? curImgObj.bigImageSize.width / 2 : curImgObj.defaultWidth.width;
                                            _height = curImgObj.bigImageSize ? curImgObj.bigImageSize.height / 2 : curImgObj.defaultWidth.height;
                                            _dragState = 3;
                                            _gameDst = matchDoneElement.gameDst;
                                            break;
                                        } else {
                                            _left = curImgObj.defaultPos.x;
                                            _top = curImgObj.defaultPos.y;
                                        }
                                    }
                                }
                                if (dragRight) {    //从正确的位置拖下来
                                    _yes--;
                                    if (_dragState === 0) {
                                        _gameDst = dragAnswerDsts[_index];
                                    }
                                } else if (window.dragAnswers[_index] === 0) {    //从错误的位置拖下来
                                    if (_dragState === 0) {
                                        _gameDst = dragAnswerDsts[_index];
                                    }
                                }
                            }
                            window.dragAnswers[_index] = _dragState === 2 || (_gameDst && _gameDst.length && _gameDst.indexOf("noDst") > -1) ? 1 : (_dragState === 3 ? 0 : -1);
                            dragAnswerDsts[_index] = _dragState === 0 ? "" : _gameDst;
                        } catch (err) {
                            // _left = left;
                            // _top = top;
                        }

                        $(moveImg).animate({
                            "top": _top,
                            "left": _left,
                        }, item.offsetTime * 20, () => {
                            that.setState({
                                drawRightTotal: _yes,
                                dragAnswerDsts: dragAnswerDsts,
                                drawTotal: Utils.countItemInArray(window.dragAnswers, 0) + Utils.countItemInArray(window.dragAnswers, 1)
                            });
                        });
                    });
                }
            }
        } else {
            if (item.detail && item.detail.src && item.detail.src.id) {
                const moveImg = document.getElementById(item.detail.src.id);
                if (moveImg) {
                    let _top = moveImg.style.top;
                    let _left = moveImg.style.left;
                    let _zIndex = $(moveImg).css('z-index');
                    $(moveImg).css({
                        "background-image": `url(${window.resourceUrl + item.detail.src.bigImage})`,
                        "z-index": _zIndex === "auto" ? 1 : _zIndex
                    }).animate({
                        "top": item.detail.end_center_pos.y * 100 + "%",
                        "left": item.detail.end_center_pos.x * 100 + "%",
                        "width": item.detail.rect && item.detail.rect.size ? item.detail.rect.size.width / 2 : item.detail.src.bigImageSize.width / 2 + "px",
                        "height": item.detail.rect && item.detail.rect.size ? item.detail.rect.size.height / 2 : item.detail.src.bigImageSize.height / 2 + "px",
                    }, item.offsetTime * 40, () => {
                        $(moveImg).animate({
                            "top": item.detail.matchType === "succ" && item.detail.rect && item.detail.rect.pos ? (item.detail.rect.pos.y * 100 + "%") : _top,
                            "left": item.detail.matchType === "succ" && item.detail.rect && item.detail.rect.pos ? (item.detail.rect.pos.x * 100 + "%") : _left,
                        }, item.offsetTime, () => {
                            $(moveImg).css({
                                // "z-index": 0
                            });
                        });
                    });
                }
            }
        }

        const playClickAudio = document.getElementById('playClickAudio');
        playClickAudio.addEventListener("ended", function () {
            console.log('end:', that.num)
            that.handleEndedAudio(that.num, false);
        }, false)
    }

    playAudio(num, flag) {  //flag-true 不需要延时
        const that = this;
        const playClickAudio = document.getElementById('playClickAudio');
        playClickAudio.setAttribute('src', '');
        setTimeout(() => {
            //播放音频
            const curPlayAudio = window.autoPlayList[num];

            if (playClickAudio && curPlayAudio) {
                playClickAudio.setAttribute('src', window.resourceUrl + 'audio/' + curPlayAudio.audio);
                const playClickAudioPromise = playClickAudio.play();
                if (playClickAudioPromise !== undefined) {
                    playClickAudioPromise.then(_ => {
                        that.num = num + 1;
                    }).catch(error => {
                        // console.log('===noplay', error)
                    });
                }

                //添加播放动画
                const targetEle = document.getElementById(curPlayAudio.id);
                if (targetEle) {
                    const oldAudioAnimation = document.getElementById("audioAnimation");
                    if (oldAudioAnimation && oldAudioAnimation.parentNode) {
                        oldAudioAnimation.parentNode.removeChild(oldAudioAnimation);
                    }
                    const audioAnimation = document.createElement("div");
                    audioAnimation.setAttribute("id", "audioAnimation");
                    audioAnimation.style.position = "absolute";
                    audioAnimation.style.top = 0;
                    audioAnimation.style.left = 0;
                    audioAnimation.style.height = "100%";
                    targetEle.appendChild(audioAnimation);
                    lottie.loadAnimation({
                        container: audioAnimation,
                        renderer: 'canvas',
                        loop: true,
                        autoplay: true,
                        path: window.animationUrl + 'match_data.json'
                    });
                }
            }
        }, flag ? 0 : 800);
    }

    //处理 AudioMutiMatchGameInteraction_ 音频播放完成
    handleEndedAudio(num, flag) {
        const that = this;
        console.log(num, that.len)

        //先移除之前添加的json动画
        const audioAnimation = document.getElementById("audioAnimation");
        if (audioAnimation && audioAnimation.parentNode) {
            audioAnimation.parentNode.removeChild(audioAnimation);
        }

        if (window.reviewDrawRightTotal === 0) { //还没有拖对的，走自动播放流程
            if (num <= that.len && window.reviewDrawRightTotal === 0) {
                that.playAudio(num, flag);
            }
        }

    }

    render() {
        const { item } = this.props;
        return (
            <div>
                {item.detail.feedbacks ?
                    <CountdownTimer feedbacks={item.detail.feedbacks} />
                    : null}
                {
                    item && item.detail && item.detail.linepoints ?
                        item.detail.linepoints.map((linepoint, index) => {
                            return (
                                <div key={index} style={{
                                    "position": "absolute",
                                    "top": linepoint.y * 100 + "%",
                                    "left": linepoint.x * 100 + "%",
                                    "width": "15px",
                                    "height": "15px",
                                    "borderRadius": "15px",
                                    "backgroundColor": "#4ec6f5"
                                }} />
                            )
                        })
                        : null
                }
            </div>
        );
    }
}

export default AutoMatch;



// WEBPACK FOOTER //
// ./src/components/review/AutoMatch.js